export default dec => dec.toString(2).padStart(8, "0");



// WEBPACK FOOTER //
// ./src/lib/decBin.js